module.exports = __webpack_public_path__ + "static/media/Cristina Savian_DT.93893b0e.jpeg";